interface SavedMessageArgs {
  isCreate: boolean;
  isFirstJob: boolean;
  /** The server kept a different week than was posted, because it merged touching windows. */
  mergedWindows: boolean;
}

const MERGED_NOTE = "Overlapping interview windows were combined.";

/** Appends the combined-windows note when the server kept a different week than was posted. */
export const withMergedNote = (message: string, mergedWindows: boolean): string =>
  mergedWindows ? `${message} ${MERGED_NOTE}` : message;

/**
 * The confirmation for a saved job.
 *
 * Two reasons this is not just the old create-only toast. Updating a job used to say nothing at all,
 * so a successful save was indistinguishable from a no-op. And the service merges touching or
 * overlapping windows, so a manager who adds 2:30-5 to a day already covered 9-5 sees their row
 * vanish into the wider one — a correct save that reads as a lost edit unless it is named.
 */
export const jobSavedMessage = ({ isCreate, isFirstJob, mergedWindows }: SavedMessageArgs): string => {
  if (!isCreate) return withMergedNote("Job updated.", mergedWindows);
  return withMergedNote(
    isFirstJob ? "🎉 Congrats on posting your first job!" : "Job posted successfully!",
    mergedWindows,
  );
};
